export default "{\n    \"subtitleText\": \"FOR RESTAURANTS\"\n}\n"